// import React, { useState } from "react";
// import { Mail, MoveRight } from "lucide-react";
// import { useNavigate } from "react-router-dom";
// import { useToast } from "../../context/ToastContext";

// const ForgotPasswordPage = () => {
//     const navigate = useNavigate();

//     const [email, setEmail] = useState("");
//     const [error, setError] = useState("");
//     const [loading, setLoading] = useState(false);

//     const { success } = useToast();


//     const validate = () => {
//         if (!email) {
//             return "Email is required";
//         } else if (!/\S+@\S+\.\S+/.test(email)) {
//             return "Enter a valid email address";
//         }
//         return "";
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         const validationError = validate();

//         if (validationError) {
//             setError(validationError);
//             return;
//         }

//         try {
//             setLoading(true);
//             setError("");

//             // 🔥 Replace with real API call
//             await new Promise((resolve) => setTimeout(resolve, 1500));


//             // redirect after 1.5s
//             setTimeout(() => {
//                 success("Reset link sent successfully. Please check your email to continue.");

//                 setLoading(false);
//                 navigate("/sign-in");

//             }, 1500);

//         } catch (err) {
//             console.error("Something went wrong. Try again.");
//             setLoading(false);
//         }
//     };

//     return (
//         <div className="min-h-screen bg-gradient-to-br from-gray-100 via-gray-200 to-gray-300 flex items-center justify-center px-4">

//             <div className="absolute inset-0  bg-gradient-to-br from-white via-indigo-50 to-pink-50"></div>

//             <div className="absolute inset-0  overflow-hidden">
//                 <div className="absolute w-[700px] h-[700px] bg-indigo-200/50 rounded-full blur-[140px] top-[-300px] left-[-200px] animate-float-slow"></div>
//                 <div className="absolute w-[600px] h-[600px] bg-pink-200/40 rounded-full blur-[140px] bottom-[-300px] right-[-150px] animate-float-slower"></div>
//             </div>

//             <div className="absolute inset-0 bg-[linear-gradient(to_right,#00000005_1px,transparent_1px),linear-gradient(to_bottom,#00000005_1px,transparent_1px)] bg-[size:60px_60px]"></div>


//             <div className="w-full max-w-md backdrop-blur-lg bg-white/80 shadow-2xl rounded-3xl p-8 border border-gray-200">

//                 {/* Logo */}
//                 <div className="flex justify-center items-center gap-2 mb-8">
//                     <div className="w-10 h-10 flex items-center justify-center">
//                         <svg
//                             xmlns="http://www.w3.org/2000/svg"
//                             width="40"
//                             height="40"
//                             viewBox="0 0 24 24"
//                             fill="none"
//                             stroke="currentColor"
//                             strokeWidth="2"
//                             strokeLinecap="round"
//                             strokeLinejoin="round"
//                             className="h-8 w-8 text-black"
//                         >
//                             <path d="m17 2-5 5-5-5"></path>
//                             <rect width="20" height="15" x="2" y="7" rx="2"></rect>
//                         </svg>
//                     </div>
//                     <h1 className="text-3xl font-semibold text-gray-900">
//                         SocialTV
//                     </h1>
//                 </div>

//                 <h2 className="text-2xl font-semibold text-gray-900 mb-2">
//                     Forgot Password
//                 </h2>
//                 <p className="text-sm text-gray-500 mb-6">
//                     Enter your email and we'll send you a reset link.
//                 </p>

//                 <form onSubmit={handleSubmit} className="space-y-5">

//                     {/* Email */}
//                     <div>
//                         <label className="block text-sm font-medium text-gray-700 mb-2">
//                             Email
//                         </label>

//                         <div className="relative">
//                             <input
//                                 type="text"
//                                 value={email}
//                                 onChange={(e) => {
//                                     setEmail(e.target.value);
//                                     setError("");
//                                 }}
//                                 placeholder="Enter Your Email"
//                                 className={`w-full px-4 py-3 rounded-xl border 
//                 ${error ? "border-red-500" : "border-gray-300"}
//                 focus:ring-1 focus:ring-black focus:border-black 
//                 outline-none transition`}
//                             />
//                             <div className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-500">
//                                 <Mail size={20} />
//                             </div>
//                         </div>

//                         {error && (
//                             <p className="text-red-500 text-sm mt-1">{error}</p>
//                         )}
//                     </div>

//                     {/* Button */}
//                     <button
//                         type="submit"
//                         disabled={loading}
//                         className="w-full flex justify-center items-center gap-2 bg-black text-white py-3 rounded-xl hover:bg-gray-900 transition font-medium disabled:opacity-70 disabled:cursor-not-allowed"
//                     >
//                         {loading ? (
//                             <>
//                                 <span className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
//                                 Sending...
//                             </>
//                         ) : (
//                             <>
//                                 <span>Send Reset Link</span>
//                                 <MoveRight size={16} />
//                             </>
//                         )}
//                     </button>

//                 </form>

//                 <div className="text-center text-sm text-gray-600 mt-6">
//                     Remember your password?{" "}
//                     <span
//                         onClick={() => navigate("/sign-in")}
//                         className="text-black font-medium cursor-pointer hover:underline"
//                     >
//                         Sign in
//                     </span>
//                 </div>

//             </div>
//         </div>
//     );
// };

// export default ForgotPasswordPage;


import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useToast } from "../../context/ToastContext";
import { Mail, MoveRight, ArrowLeft, Shield, CheckCircle } from "lucide-react";

const ForgotPasswordPage = () => {
    const navigate = useNavigate();
    const [mounted, setMounted] = useState(false);

    const [email, setEmail] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const [focused, setFocused] = useState(false);
    const [sent, setSent] = useState(false);

    const { success } = useToast();

    useEffect(() => {
        setMounted(true);
    }, []);

    const validate = () => {
        if (!email) {
            return "Email is required";
        } else if (!/\S+@\S+\.\S+/.test(email)) {
            return "Enter a valid email address";
        }
        return "";
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const validationError = validate();

        if (validationError) {
            setError(validationError);
            return;
        }

        try {
            setLoading(true);
            setError("");

            // Simulate API call
            await new Promise((resolve) => setTimeout(resolve, 1500));

            setSent(true);

            setTimeout(() => {
                success("Reset link sent successfully! Check your email to continue.");
                setLoading(false);
                navigate("/sign-in");
            }, 2000);

        } catch (err) {
            console.error("Something went wrong. Try again.");
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-gradient-to-br from-indigo-50 via-white to-purple-50 flex items-center justify-center p-4 relative overflow-hidden">

            {/* Soft Background Elements */}
            {/* <div className="absolute inset-0 overflow-hidden">
                <div className={`absolute w-[800px] h-[800px] bg-indigo-200/30 rounded-full blur-[120px] top-[-400px] left-[-200px] transition-all duration-1000 ${mounted ? 'opacity-100' : 'opacity-0'}`}></div>
                <div className={`absolute w-[600px] h-[600px] bg-purple-200/30 rounded-full blur-[120px] bottom-[-300px] right-[-100px] transition-all duration-1000 delay-300 ${mounted ? 'opacity-100' : 'opacity-0'}`}></div>
                <div className="absolute inset-0 bg-[linear-gradient(to_right,#f0f0f0_1px,transparent_1px),linear-gradient(to_bottom,#f0f0f0_1px,transparent_1px)] bg-[size:40px_40px]"></div>
            </div> */}

            <div className="absolute inset-0 overflow-hidden">
                <div className={`absolute w-[800px] h-[800px] rounded-full bg-indigo-300/20 blur-[160px] top-[-500px] left-[-300px] transition-all duration-1000 ${mounted ? 'opacity-100' : 'opacity-0'}`}></div>
                <div className={`absolute w-[800px] h-[800px] rounded-full bg-blue-300/20 blur-[150px] bottom-[-400px] right-[-250px] transition-all duration-1000 delay-300 ${mounted ? 'opacity-100' : 'opacity-0'}`}></div>
                <div className={`absolute w-[700px] h-[700px] rounded-full bg-violet-300/20 blur-[140px] top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 transition-all duration-1000 delay-500 ${mounted ? 'opacity-100' : 'opacity-0'}`}></div>
                <div className={`absolute w-[500px] h-[500px] rounded-full bg-pink-200/25 blur-[120px] top-1/4 right-1/4 transition-all duration-1000 delay-700 ${mounted ? 'opacity-100' : 'opacity-0'}`}></div>
            </div>

            {/* Main Card */}
            <div className={`w-full max-w-4xl relative transition-all duration-1000 transform ${mounted ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`}>
                <div className="bg-white rounded-3xl shadow-xl overflow-hidden border border-gray-200">
                    <div className="grid md:grid-cols-2">

                        {/* Left Side - Help & Support */}
                        <div className="relative p-8 md:p-10 bg-gradient-to-br from-indigo-50 to-purple-50 flex flex-col">

                            {/* Logo */}
                            <div className="flex items-center gap-3 mb-8">
                                <div className="w-10 h-10 bg-gradient-to-br from-indigo-500 to-purple-500 rounded-lg flex items-center justify-center shadow-sm">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <path d="m17 2-5 5-5-5"></path>
                                        <rect width="20" height="15" x="2" y="7" rx="2"></rect>
                                    </svg>
                                </div>
                                <h1 className="text-2xl font-semibold text-gray-800">
                                    SocialTV
                                </h1>
                            </div>

                            {/* Help Content */}
                            <div className="relative z-10 flex-1 flex flex-col">
                                <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-4">
                                    Need help with<br />
                                    <span className="text-indigo-600">
                                        your account?
                                    </span>
                                </h2>

                                <p className="text-gray-600 mb-6 leading-relaxed">
                                    Don't worry! We'll help you reset your password and get back to creating amazing TV ads.
                                </p>

                                {/* Support Options */}
                                <div className="space-y-4 mb-6">
                                    <div className="flex items-start gap-3">
                                        <div className="w-6 h-6 rounded-full bg-indigo-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                                            <span className="text-indigo-600 text-xs font-bold">1</span>
                                        </div>
                                        <div>
                                            <h3 className="font-medium text-gray-800">Check your inbox</h3>
                                            <p className="text-sm text-gray-500">We'll send a reset link to your email</p>
                                        </div>
                                    </div>
                                    <div className="flex items-start gap-3">
                                        <div className="w-6 h-6 rounded-full bg-indigo-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                                            <span className="text-indigo-600 text-xs font-bold">2</span>
                                        </div>
                                        <div>
                                            <h3 className="font-medium text-gray-800">Click the reset link</h3>
                                            <p className="text-sm text-gray-500">Valid for 24 hours for security</p>
                                        </div>
                                    </div>
                                    <div className="flex items-start gap-3">
                                        <div className="w-6 h-6 rounded-full bg-indigo-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                                            <span className="text-indigo-600 text-xs font-bold">3</span>
                                        </div>
                                        <div>
                                            <h3 className="font-medium text-gray-800">Create new password</h3>
                                            <p className="text-sm text-gray-500">Choose a strong, unique password</p>
                                        </div>
                                    </div>
                                </div>

                                {/* Contact Support */}
                                <div className="mt-auto pt-6 border-t border-indigo-100">
                                    <p className="text-xs text-gray-500">
                                        Still having trouble?{" "}
                                        <button className="text-indigo-600 hover:underline font-medium">
                                            Contact support
                                        </button>
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* Right Side - Forgot Password Form */}
                        <div className="p-8 md:p-10 bg-white flex flex-col">

                            {/* Back to Login */}
                            <button
                                onClick={() => navigate("/sign-in")}
                                className="flex items-center gap-2 text-sm text-gray-500 hover:text-gray-700 mb-6 group w-fit"
                            >
                                <ArrowLeft size={16} className="group-hover:-translate-x-1 transition-transform" />
                                Back to sign in
                            </button>

                            {/* Form Header */}
                            <div className="mb-6">
                                <h3 className="text-2xl font-semibold text-gray-800 mb-2">
                                    Reset password
                                </h3>
                                <p className="text-sm text-gray-500">
                                    Enter your email address and we'll send you a link to reset your password.
                                </p>
                            </div>

                            {/* Success State */}
                            {sent ? (
                                <div className="flex flex-col items-center justify-center py-8 animate-slideIn">
                                    <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-4">
                                        <CheckCircle className="w-8 h-8 text-green-500" />
                                    </div>
                                    <h4 className="text-lg font-semibold text-gray-800 mb-2">Check your email</h4>
                                    <p className="text-sm text-gray-500 text-center mb-4">
                                        We've sent a reset link to<br />
                                        <span className="font-medium text-gray-700">{email}</span>
                                    </p>
                                    <p className="text-xs text-gray-400 text-center">
                                        Didn't receive it? Check your spam folder or{" "}
                                        <button
                                            onClick={() => setSent(false)}
                                            className="text-indigo-600 hover:underline"
                                        >
                                            try again
                                        </button>
                                    </p>
                                </div>
                            ) : (
                                /* Form */
                                <form onSubmit={handleSubmit} className="space-y-5">

                                    {/* Email */}
                                    <div className="space-y-1.5">
                                        <label className="block text-sm font-medium text-gray-700">
                                            Email Address
                                        </label>
                                        <div className="relative">
                                            <input
                                                type="email"
                                                value={email}
                                                onChange={(e) => {
                                                    setEmail(e.target.value);
                                                    setError("");
                                                }}
                                                onFocus={() => setFocused(true)}
                                                onBlur={() => setFocused(false)}
                                                placeholder="you@example.com"
                                                className={`w-full px-4 py-3 rounded-lg border transition-all duration-200 pl-10
                                                    ${error
                                                        ? "border-red-300 bg-red-50/50"
                                                        : focused
                                                            ? "border-indigo-300 bg-indigo-50/30"
                                                            : "border-gray-200 bg-gray-50"
                                                    }
                                                    outline-none focus:ring-1
                                                    ${error
                                                        ? "focus:ring-red-100"
                                                        : "focus:ring-indigo-100"
                                                    }
                                                    text-sm`}
                                            />
                                            <Mail className={`absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 transition-colors
                                                ${error
                                                    ? "text-red-400"
                                                    : focused
                                                        ? "text-indigo-400"
                                                        : "text-gray-400"
                                                }`}
                                            />
                                        </div>
                                        {error && (
                                            <p className="text-red-500 text-xs mt-1 animate-slideIn">
                                                {error}
                                            </p>
                                        )}
                                    </div>

                                    {/* Help Tip */}
                                    <div className="bg-blue-50/50 rounded-lg p-3 border border-blue-100">
                                        <p className="text-xs text-blue-700 flex items-start gap-2">
                                            <svg className="w-4 h-4 flex-shrink-0 mt-0.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                <circle cx="12" cy="12" r="10" />
                                                <path d="M12 16v-4M12 8h.01" />
                                            </svg>
                                            <span>
                                                Make sure to check your spam folder if you don't see the email in your inbox within a few minutes.
                                            </span>
                                        </p>
                                    </div>

                                    {/* Submit Button */}
                                    <button
                                        type="submit"
                                        disabled={loading}
                                        className="w-full flex items-center justify-center gap-2 bg-indigo-600 text-white py-3 rounded-lg hover:bg-indigo-700 transition-all font-medium text-sm disabled:opacity-70 disabled:cursor-not-allowed mt-4"
                                    >
                                        {loading ? (
                                            <>
                                                <span className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
                                                Sending reset link...
                                            </>
                                        ) : (
                                            <>
                                                <span>Send Reset Link</span>
                                                <MoveRight size={16} />
                                            </>
                                        )}
                                    </button>

                                    {/* Security Note */}
                                    <p className="text-xs text-gray-400 text-center mt-4">
                                        <span className="flex items-center justify-center gap-1">
                                            <Shield size={12} />
                                            Your information is protected by enterprise-grade security
                                        </span>
                                    </p>
                                </form>
                            )}

                            {/* Alternative Options */}
                            {!sent && (
                                <div className="mt-6 pt-6 border-t border-gray-100">
                                    <p className="text-xs text-center text-gray-500">
                                        Remember your password?{" "}
                                        <button
                                            onClick={() => navigate("/sign-in")}
                                            className="text-indigo-600 hover:text-indigo-700 font-medium hover:underline"
                                        >
                                            Sign in
                                        </button>
                                    </p>
                                    <p className="text-xs text-center text-gray-400 mt-2">
                                        Don't have an account?{" "}
                                        <button
                                            onClick={() => navigate("/sign-up")}
                                            className="text-indigo-600 hover:text-indigo-700 font-medium hover:underline"
                                        >
                                            Sign up
                                        </button>
                                    </p>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            {/* Add custom animations */}
            <style jsx>{`
                @keyframes slideIn {
                    from {
                        opacity: 0;
                        transform: translateY(10px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }
                .animate-slideIn {
                    animation: slideIn 0.3s ease-out;
                }
            `}</style>
        </div>
    );
};

export default ForgotPasswordPage;